export default __webpack_public_path__ + "static/media/Angel God@2x-min.e78bad8e.png";